export default "__VITE_ASSET__uZNzbZK4__"